import "bootstrap/dist/css/bootstrap.min.css";
import GetIcon from "../../utils/Icon";
import { useEffect, useState, useCallback } from "react";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import ReactBarChart from "../../utils/Dashboard/Chart/BarChart";
import ReactLineChart from "../../utils/Dashboard/Chart/LineChart";
import ReactDonutChart from "../../utils/Dashboard/Chart/DonutChart";
import CartFilterPopup from "../../utils/Dashboard/Cart_Filter_Popup";
import ChartFilterPopup from "../../utils/Dashboard/Chart_Filter_Popup";
import { useGetSelectedCompanyQuery } from "../../store/api/companyapi";
import { usePostDashboardChartMutation, usePostDashboardChartThreeMutation, usePostDashboardChartTwoMutation, usePostDashboardCountMutation, usePostDashboardCounttwoMutation, usePostDashboardPercentageCountMutation } from "../../store/api/dashboard";
import { Active_Customer_Count_Payload, Total_Active_Items_Count_Payload, createFilterState, Total_Stock_Value_Count_Payload, Total_Warehouses_Count_Payload, Total_Qty_Grn_Detail_Count_Payload, Total_Qty_Grn_Detail_Count_Payload2, Total_Qty_Sell_Order_Detail_Count_Payload, Total_Qty_Sales_Order_Detail_Count_Payload2, Total_Qty_Sales_Invoice_Detail_Count_Payload, Total_Qty_Sales_Invoice_Detail_Count_Payload2 } from "./utils/DashboardData";
import Tabs from "../../Components/Tabs";
import NumberCard from "./NumberCard";
import DashTable from "./DashboardTable/DashTable";
import { Helmet } from "react-helmet";


const Dashboard = () => {
  // API hooks
  const [ChartDataApi] = usePostDashboardChartMutation();
  const [ChartDataApi2] = usePostDashboardChartTwoMutation();
  const [ChartDataApi3] = usePostDashboardChartThreeMutation();
  const [CountApi] = usePostDashboardCountMutation();
  const [CountApi2] = usePostDashboardCounttwoMutation();
  const { data } = useGetSelectedCompanyQuery();
  const selectedComapny = data?.message?.data?.company.split(' - ')[0];

  // UI state
  const [showpopup, setShowpopup] = useState(false);
  const [showChartPopup, setShowChartPopup] = useState(false);
  const [currentChartType, setCurrentChartType] = useState(null);
  const [currentFilterType, setCurrentFilterType] = useState(null);

  // Chart State
  const [Purchase_order_trends, setPurchase_order_trends] = useState({});
  const [Material_Request_Analysis, setMaterial_Request_Analysis] = useState({});
  const [Purchase_order_analysis, setPurchase_order_analysis] = useState({});
  const [item_wise_annual_Purchase, setitem_wise_annual_Purchase] = useState({});
  const [item_Shortage_Summary, setitem_Shortage_Summary] = useState({});









    const initialCountState = { count: 0, percentage: 0 };
    const [GrnInfoCount, setGrnInfoCount] = useState(initialCountState);
    const [SalesOrderInfoCount, setSalesOrderInfoCount] = useState(initialCountState);
    const [SalesInvoiceInfoCount, setSalesInvoiceInfoCount] = useState(initialCountState);
    const [PutAwayInfoCount, setPutAwayInfoCount] = useState(initialCountState);
    const [PickListInfoCount, setPickListInfoCount] = useState(initialCountState);
    const [DeliveryNoteInfoCount, setDeliveryNoteInfoCount] = useState(initialCountState);
    const [GateEntryandPendingGRNCount, setGateEntryandPendingGRNCount] = useState(initialCountState);



   console.log("GateEntryandPendingGRNCountGateEntryandPendingGRNCount",GateEntryandPendingGRNCount)




  // Filter States 
  const [PurchaseOrderTrendsFilters, setPurchaseOrderTrendsFilters] = useState({period: "Monthly",based_on: "Item",fiscal_year: "2025-2026",company: selectedComapny});
  const [ReceiveTrendsFilters, setReceiveTrendsFilters] = useState({period: "quarter",based_on: "Customer",fiscal_year: "2025-2026",company: selectedComapny});
  const [PurchaseOrderAnalysisFilters, setPurchaseOrderAnalysisFilters] = useState({from_date: "", to_date: "",status: [], company: selectedComapny});
  const [ItemWiseAnnualPurchaseFilters, setItemWiseAnnualPurchaseFilters] = useState({from_date: "",to_date: "",company: selectedComapny});


  const [Total_Grn_Detail_Filters, setTotal_Grn_Detail_Filters] = useState({dateFilters: [{label: "From Date", value: ""}, {label: "To Date", value: ""}]});
  const [Total_Sales_Order_Detail_Filters, setTotal_Sales_Order_Detail_Filters] = useState({dateFilters: [{label: "From Date", value: ""}, {label: "To Date", value: ""}]});
  const [Total_Selling_Invoice_Detail_Filters, setTotal_Selling_Invoice_Detail_Filters] = useState({dateFilters: [{label: "From Date", value: ""}, {label: "To Date", value: ""}]});
   
  
  const [Total_Putaway_Detail_Filters, setTotal_Putaway_Detail_Filters] = useState({dateFilters: [{label: "From Date", value: ""}, {label: "To Date", value: ""}]});
  const [Total_Pick_List_Detail_Filters, setTotal_Pick_List_Detail_Filters] = useState({dateFilters: [{label: "From Date", value: ""}, {label: "To Date", value: ""}]});
  const [Total_delivery_note_Filters, setTotal_delivery_note_Filters] = useState({dateFilters: [{label: "From Date", value: ""}, {label: "To Date", value: ""}]});

  const [Total_GateEntry_PendingGRN_Filters, setTotal_GateEntry_PendingGRN_Filters] = useState({dateFilters: [{label: "From Date", value: ""}, {label: "To Date", value: ""}]});

  // Helper functions
  const getCurrentChartFilters = useCallback(() => {
    const chartFilters = {
      "Purchase_Order_Trends": PurchaseOrderTrendsFilters,
      "Material_Request_Analysis": ReceiveTrendsFilters,
      "Purchase_Order_Analysis": PurchaseOrderAnalysisFilters,
      "Item_Wise_Annual_Purchase": ItemWiseAnnualPurchaseFilters
    };
    return chartFilters[currentChartType] || {};
  }, [currentChartType, PurchaseOrderTrendsFilters, ReceiveTrendsFilters, PurchaseOrderAnalysisFilters, ItemWiseAnnualPurchaseFilters]);

 

  const updateFilters = useCallback((filterType, newFilters) => {
    const filterSetters = {
      'Purchase_Order_Trends': setPurchaseOrderTrendsFilters,
      'Material_Request_Analysis': setReceiveTrendsFilters,
      'Purchase_Order_Analysis': setPurchaseOrderAnalysisFilters,
      'Item_Wise_Annual_Purchase': setItemWiseAnnualPurchaseFilters
    };

    filterSetters[filterType]?.((prev) => ({ ...prev, ...newFilters }));
  }, []);

  // API call functions
  const buildFilters = useCallback((
     doctype = "Purchase Order",
     field = "modified", 
     fromDate = "",
     toDate = "",
     statusFilters = []) => {
    // const baseFilters = [];
    // if (doctype === "Purchase Order") {
    //   baseFilters.push(
    //     ["Purchase Order", "transaction_date", "Timespan", "this year", false],
    //     [doctype, "status", "in", statusFilters.length ? statusFilters : ["Draft", "Cancelled", "Closed", null], false],
    //     [doctype, "company", "=", selectedComapny],
    //     [doctype, "docstatus", "=", "1", false]
    //   );
    // } else if (doctype === "Customer") {
    //   baseFilters.push([doctype, "disabled", "=", "0", false]);
    // }

    // if (fromDate && toDate && field) {
    //   baseFilters.push([doctype, field, "Between", [fromDate, toDate], false]);
    // }

    // return baseFilters;




     const filters = [];


  if (selectedComapny) {
    filters.push([doctype, "company", "=", selectedComapny, false]);
  }

  // Add date range filter
  if (fromDate && toDate && field) {
    filters.push([doctype, field, "Between", [fromDate, toDate], false]);
  }

  // Doctype-specific filters
  switch (doctype) {
    case "Purchase Order":
      filters.push(
        [doctype, "docstatus", "=", "1", false],
        [doctype, "status", "in", statusFilters.length ? statusFilters : ["Draft", "Cancelled", "Closed", null], false]
      );
      break;

    case "Customer":
      filters.push([doctype, "disabled", "=", "0", false]);
      break;

    // Add more doctypes here as needed
  }

  return filters;
  }, [selectedComapny]);

// 1. First, update your ChartApi function to be more flexible:
const ChartApi = useCallback(async (type, filter, setState, apiCall) => {
  if (!selectedComapny) return;

  try {
    // const formData = new FormData();
    // formData.append("report_name", type);
    // formData.append("filters", JSON.stringify(filter));
    // formData.append("ignore_prepared_report", 1);
    
    // const response = apiNo === 1 
    //   ? await ChartDataApi(filter)
    //   : await ChartDataApi2(filter);

    const response = await apiCall(filter);
       console.log("check response here",response);
    setState(response.data.message);
  } catch (error) {
    console.error(`Error fetching ${type}:`, error);
  }
}, [ChartDataApi, ChartDataApi2, selectedComapny]);





// 2. Then update your Material Request Analysis useEffect:
useEffect(() => {
  if (!selectedComapny) return;

  const { period, fiscal_year, based_on } = ReceiveTrendsFilters;
  

  const filters = [
    // ["Material Request", "status", "not in", ["Draft", "Cancelled", "Stopped", null], false],
    // ["Material Request", "material_request_type", "=", "Purchase", false],
    ["Purchase Receipt", "docstatus", "=", "1", false]
    // ["Material Request", "transaction_date", "Timespan", period === "Yearly" ? "last year" : "last quarter", false],
    // ["Material Request", "company", "=", selectedComapny, false]
  ];
  const formData = new FormData();
  formData.append("chart_name", "Purchase Receipt Trends");
  formData.append("filters", JSON.stringify(filters));
  // formData.append("refresh","");
  // formData.append("time_interval","");
  // formData.append("timespan","");
  // formData.append("from_date","");
  // formData.append("to_date","");
  // formData.append("heatmap_year","");

  ChartApi(
    "Purchase Receipt Trends", 
     formData, 
    setMaterial_Request_Analysis,
    ChartDataApi2
  );
}, [ReceiveTrendsFilters, selectedComapny, ChartApi]);








// 3. Similarly for other chart effects:
useEffect(() => {
  if (!selectedComapny) return;
   const { period, fiscal_year, based_on } = PurchaseOrderTrendsFilters;
  

  const filters = {
    // "period":period,
    // "based_on":"Item",
    // "fiscal_year":fiscal_year,
    // "company":selectedComapny
};
  const formData = new FormData();
  formData.append("chart_name", "Warehouse wise Stock Value");
  formData.append("filters", JSON.stringify(filters));
  // formData.append("ignore_prepared_report",1);

  ChartApi(
    "Purchase Order Trends", 
    formData,
    setPurchase_order_trends,
    ChartDataApi3
  );
}, [PurchaseOrderTrendsFilters, selectedComapny, ChartApi]);


useEffect(() => {
  if (!selectedComapny) return;
    const { to_date, from_date } = PurchaseOrderAnalysisFilters;

//   const filters = {
//     "group_by_po":0,
//     "company":selectedComapny,
//     "from_date":from_date,
//     "to_date":to_date
// };

  const filters = [
    // ["Material Request", "status", "not in", ["Draft", "Cancelled", "Stopped", null], false],
    // ["Material Request", "material_request_type", "=", "Purchase", false],
    ["Delivery Note", "docstatus", "=", "1", false]
    // ["Material Request", "transaction_date", "Timespan", period === "Yearly" ? "last year" : "last quarter", false],
    // ["Material Request", "company", "=", selectedComapny, false]
  ];
  const formData = new FormData();
  formData.append("chart_name", "Delivery Trends");
  formData.append("filters", JSON.stringify(filters));
  // formData.append("ignore_prepared_report",1);


  ChartApi(
    "Delivery Trends", 
    formData,
    setPurchase_order_analysis,
    ChartDataApi2
  );
}, [PurchaseOrderAnalysisFilters, selectedComapny, ChartApi]);

useEffect(() => {
  if (!selectedComapny) return;
  
  const { period, fiscal_year, based_on } = PurchaseOrderTrendsFilters;
  

  const filters = {
    "range":"30, 60, 90",
    "show_warehouse_wise_stock":"0",
    "to_date":"2025-08-11",
    "company":selectedComapny
};
  const formData = new FormData();
  formData.append("report_name", "Stock Ageing");
  formData.append("filters", JSON.stringify(filters));
  formData.append("ignore_prepared_report",1);

  
  ChartApi(
    "Stock Ageing", 
    formData,
    setitem_wise_annual_Purchase,
    ChartDataApi
  );
}, [ItemWiseAnnualPurchaseFilters, selectedComapny, ChartApi]);

useEffect(() => {
  if (!selectedComapny) return;
  
  const { period, fiscal_year, based_on } = PurchaseOrderTrendsFilters;
  

  const filters = {
    // "range":"30, 60, 90",
    // "show_warehouse_wise_stock":"0",
    // "to_date":"2025-08-11",
    "company":selectedComapny
};
  const formData = new FormData();
  formData.append("report_name", "Item Shortage Report");
  formData.append("filters", JSON.stringify(filters));
  formData.append("ignore_prepared_report",1);

  
  ChartApi(
    "Item Shortage Report", 
    formData,
    setitem_Shortage_Summary,
    ChartDataApi
  );
}, [ItemWiseAnnualPurchaseFilters, selectedComapny, ChartApi]);



  // Effect hooks for data fetching
  
  
  




  // useEffect(() => {
  //   if (!selectedComapny) return;
  //   ChartApi("Purchase Order Trends", PurchaseOrderTrendsFilters, setPurchase_order_trends,1);
  // }, [PurchaseOrderTrendsFilters, selectedComapny, ChartApi]);


  // useEffect(() => {
  //   if (!selectedComapny) return;    
  //   ChartApi("Material Request Analysis", ReceiveTrendsFilters, setMaterial_Request_Analysis,2);
  // }, [ReceiveTrendsFilters, selectedComapny, ChartApi]);

  // useEffect(() => {
  //   if (!selectedComapny) return;
  //   ChartApi("Purchase Order Analysis", PurchaseOrderAnalysisFilters, setPurchase_order_analysis,2);
  // }, [PurchaseOrderAnalysisFilters, selectedComapny, ChartApi]);

  // useEffect(() => {
  //   if (!selectedComapny) return;
  //   ChartApi("Item-wise Sales History", ItemWiseAnnualPurchaseFilters, setitem_wise_annual_Purchase,2);
  // }, [ItemWiseAnnualPurchaseFilters, selectedComapny, ChartApi]);





  // For Gate Entry And Pending Grn
  useEffect(() => {
    if (!selectedComapny) return;

    const Count = async (docData, filtersData, Count) => {
      if (!selectedComapny) return;
      try {
        const formData = new FormData();
        formData.append('doctype', docData);
        formData.append('fields', JSON.stringify(filtersData));
        formData.append('distinct', true);

        const response = await CountApi2(formData);
        formData.append('filters', JSON.stringify([["Gate Entry Table", "purchase_receipt", "is", "not set"]]));
        const response2 = await CountApi2(formData);
        Count({ total_gate_entry: response.data.message, pending_gate_entry: response2.data.message })


      } catch (error) {
        console.error("Error in Find_Annual_Purchase_Count:", error);
      }
    };

    const { timeInterval, dateFilters, statusFilters } = Total_GateEntry_PendingGRN_Filters;
    const fromDate = dateFilters.find(f => f.label === "From Date")?.value;
    const toDate = dateFilters.find(f => f.label === "To Date")?.value;

    const filters = [];
    Count("Gate Entry", filters, setGateEntryandPendingGRNCount, true);

  }, [Total_GateEntry_PendingGRN_Filters, selectedComapny]);

  
    // For Grn qty, amount
    useEffect(() => {
      if (!selectedComapny) return;
      const { dateFilters } = Total_Grn_Detail_Filters;
  
      let fromDate = dateFilters.find(f => f.label === "From Date")?.value;
      let toDate = dateFilters.find(f => f.label === "To Date")?.value;
  
      if (!fromDate || !toDate) {
        const today = new Date();
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
  
        const formatDate = (d) => d.toISOString().split("T")[0];
        fromDate = formatDate(yesterday);
        toDate = formatDate(today);
      }
  
      const filters = [["Purchase Receipt", "posting_date", "Between", [fromDate, toDate], false]];
  
      const CountDataApi = async (filters, store) => {
        if (!selectedComapny) return;
        try {
          const formData = new FormData();
          formData.append('doc', JSON.stringify(Total_Qty_Grn_Detail_Count_Payload));
          formData.append('filters', JSON.stringify(filters));
          const response = await CountApi(formData);
  
          const formData2 = new FormData();
          formData2.append('doc', JSON.stringify(Total_Qty_Grn_Detail_Count_Payload2));
          formData2.append('filters', JSON.stringify(filters));
          const response2 = await CountApi(formData2);
  
          const formData3 = new FormData();
          formData3.append('doctype', "Purchase Receipt");
          formData3.append('filters', JSON.stringify(filters));
          const response3 = await CountApi2(formData3);
  
          store({
            option1: response.data.message,  //qty
            option2: response2.data.message,  //amount
            option3: response3.data.message // No. of GRN
          });
  
        } catch (error) {
          console.error("Error in Find_Annual_Purchase_Count:", error);
        }
      };
  
      CountDataApi(filters, setGrnInfoCount);
  
    }, [Total_Grn_Detail_Filters, selectedComapny]);
  
  // for sell order detail 
  useEffect(() => {
    if (!selectedComapny) return;
    const { dateFilters } = Total_Sales_Order_Detail_Filters;

    let fromDate = dateFilters.find(f => f.label === "From Date")?.value;
    let toDate = dateFilters.find(f => f.label === "To Date")?.value;

    if (!fromDate || !toDate) {
      const today = new Date();
      const yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);

      const formatDate = (d) => d.toISOString().split("T")[0];
      fromDate = formatDate(yesterday);
      toDate = formatDate(today);
    }

    const filters = [["Sales Order", "transaction_date", "Between", [fromDate, toDate], false]];

    const CountDataApi = async (filters, store) => {
      if (!selectedComapny) return;
      try {
        const formData = new FormData();
        formData.append('doc', JSON.stringify(Total_Qty_Sell_Order_Detail_Count_Payload));
        formData.append('filters', JSON.stringify(filters));
        const response = await CountApi(formData);

        const formData2 = new FormData();
        formData2.append('doc', JSON.stringify(Total_Qty_Sales_Order_Detail_Count_Payload2));
        formData2.append('filters', JSON.stringify(filters));
        const response2 = await CountApi(formData2);

        const formData3 = new FormData();
        formData3.append('doctype', "Sales Order");
        formData3.append('filters', JSON.stringify(filters));
        formData3.append('distinct', false);
        const response3 = await CountApi2(formData3);

        store({
          option1: response2.data.message, // QTY
          option2: response.data.message,  // AMOUNT
          option3: response3.data.message  // No. of Sales Order
        });

      } catch (error) {
        console.error("Error in Find_Annual_Purchase_Count:", error);
      }
    };

    CountDataApi(filters, setSalesOrderInfoCount);

  }, [Total_Sales_Order_Detail_Filters, selectedComapny]);

  // for sell invoice detail 
  useEffect(() => {
    if (!selectedComapny) return;
    const { dateFilters } = Total_Selling_Invoice_Detail_Filters;

    let fromDate = dateFilters.find(f => f.label === "From Date")?.value;
    let toDate = dateFilters.find(f => f.label === "To Date")?.value;

    if (!fromDate || !toDate) {
      const today = new Date();
      const yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);

      const formatDate = (d) => d.toISOString().split("T")[0];
      fromDate = formatDate(yesterday);
      toDate = formatDate(today);
    }

    const filters = [["Sales Invoice", "posting_date", "Between", ["2025-08-08", toDate], false]];

    const CountDataApi = async (filters, store) => {
      if (!selectedComapny) return;
      try {
        const formData = new FormData();
        formData.append('doc', JSON.stringify(Total_Qty_Sales_Invoice_Detail_Count_Payload));
        formData.append('filters', JSON.stringify(filters));
        const response = await CountApi(formData);

        const formData2 = new FormData();
        formData2.append('doc', JSON.stringify(Total_Qty_Sales_Invoice_Detail_Count_Payload2));
        formData2.append('filters', JSON.stringify(filters));
        const response2 = await CountApi(formData2);

        const formData3 = new FormData();
        formData3.append('doctype', "Sales Invoice");
        formData3.append('filters', JSON.stringify(filters));
        formData3.append('distinct', false);
        const response3 = await CountApi2(formData3);

        store({
          option1: response2.data.message, //qty
          option2: response.data.message,  // amount
          option3: response3.data.message  // sales invoice
        });

      } catch (error) {
        console.error("Error in Find_Annual_Purchase_Count: dddddddd", error);
      }
    };

    CountDataApi(filters, setSalesInvoiceInfoCount);

  }, [Total_Selling_Invoice_Detail_Filters, selectedComapny]);


     // for Putaway qty,value,rcords 
     useEffect(() => {
       if (!selectedComapny) return;
       const { dateFilters } = Total_Putaway_Detail_Filters;
   
       let fromDate = dateFilters.find(f => f.label === "From Date")?.value;
       let toDate = dateFilters.find(f => f.label === "To Date")?.value;
   
       if (!fromDate || !toDate) {
         const today = new Date();
         const yesterday = new Date();
         yesterday.setDate(today.getDate() - 1);
   
         const formatDate = (d) => d.toISOString().split("T")[0];
         fromDate = formatDate(yesterday);
         toDate = formatDate(today);
       }
   
       const filters = [["Stock Entry", "posting_date", "Between", [fromDate, toDate], false]];
   
       const CountDataApi = async (filters, store) => {
         if (!selectedComapny) return;
         try {
           const formData = new FormData();
           formData.append('doctype', 'Purchase Receipt');
           formData.append('filters', JSON.stringify([["Purchase Receipt", "wms_status", "like", "%Completely Putway%"]]));
           formData.append('distinct', false);
           const response = await CountApi2(formData);
   
           const formData2 = new FormData();
           formData2.append('doctype', 'Stock Entry');
           formData2.append('filters', JSON.stringify([["Stock Entry","docstatus","=","0"]]));
           formData2.append('distinct', false);
           const response2 = await CountApi2(formData2);
   
           const formData3 = new FormData();
           formData3.append('doctype', "Stock Entry");
           formData3.append('filters', JSON.stringify([["Stock Entry","docstatus","=","1"]]));
           formData3.append('distinct', false);
           const response3 = await CountApi2(formData3);
   
           store({
             option1: response.data.message, // pending
             option2: response2.data.message, // process
             option3: response3.data.message // complete
           });
   
         } catch (error) {
           console.error("Error in Find_Annual_Purchase_Count:", error);
         }
       };
   
       CountDataApi(filters, setPutAwayInfoCount);
   
     }, [Total_Putaway_Detail_Filters, selectedComapny]);
   
      // for pick list detail 
  useEffect(() => {
    console.log("check 111 api ")
    if (!selectedComapny) return;
    const { dateFilters } = Total_Pick_List_Detail_Filters;
    console.log("check 112 api ")

    let fromDate = dateFilters.find(f => f.label === "From Date")?.value;
    let toDate = dateFilters.find(f => f.label === "To Date")?.value;

    if (!fromDate || !toDate) {
      const today = new Date();
      const yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);

      const formatDate = (d) => d.toISOString().split("T")[0];
      fromDate = formatDate(yesterday);
      toDate = formatDate(today);
    }

    const filters = [["Pick List", "date", "Between", [fromDate, toDate], false]];

    const CountFunApi = async (filters, store) => {
      console.log("check pick ed qty");
      if (!selectedComapny) return;
      try {
        console.log("check pick ed qty 2")
        const formData = new FormData();
        formData.append('doctype', 'Sales Order');
        formData.append('filters', JSON.stringify([["Sales Order", "intozi_status", "not in", ["Pick List Created", "Partially Picked", "Completely Picked"]]]));
        formData.append('distinct', true);
        const response = await CountApi2(formData);

        console.log("check respose is here1", response);

        const formData2 = new FormData();
        formData2.append('doctype', 'Pick List');
        formData2.append('filters', JSON.stringify([["Pick List Item", "sales_order", "is", "set"], ["Pick List", "status", "not in", ["Draft", null]]]));
        formData2.append('distinct', true);
        // formData2.append('fields', []);
        const response2 = await CountApi2(formData2);
        console.log("check respose is here2", response2)

        const formData3 = new FormData();
        formData3.append('doctype', 'Pick List');
        formData3.append('filters', JSON.stringify([["Pick List Item", "sales_order", "is", "set"], ["Pick List", "status", "in", ["Draft", null]]]));
        formData3.append('distinct', true);
        const response3 = await CountApi2(formData3);
        console.log("check respose is here3", response3)


        store({
          option1: response.data.message, // pending
          option2: response2.data.message, // process
          option3: response3.data.message  // complete
        });

      } catch (error) {
        console.error("Error in Find_Annual_Purchase_Count:", error);
      }
    };

    CountFunApi(filters, setPickListInfoCount);

  }, [Total_Pick_List_Detail_Filters, selectedComapny]);


  // for delivery note detail 
  useEffect(() => {
    console.log("check 111 api ")
    if (!selectedComapny) return;
    const { dateFilters } = Total_delivery_note_Filters;
    console.log("check 112 api ")

    let fromDate = dateFilters.find(f => f.label === "From Date")?.value;
    let toDate = dateFilters.find(f => f.label === "To Date")?.value;

    if (!fromDate || !toDate) {
      const today = new Date();
      const yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);

      const formatDate = (d) => d.toISOString().split("T")[0];
      fromDate = formatDate(yesterday);
      toDate = formatDate(today);
    }

    const filters = [["Pick List", "date", "Between", [fromDate, toDate], false]];

    const CountFunApi = async (filters, store) => {
      console.log("check pick ed qty");
      if (!selectedComapny) return;
      try {
        const formData = new FormData();
        formData.append('doctype', 'Pick List');
        formData.append('filters', JSON.stringify([["Pick List", "docstatus", "=", "1"], ["Pick List", "pick_status_st", "is", "not set"],]));
        formData.append('distinct', false);
        const response = await CountApi2(formData);


        const formData2 = new FormData();
        formData2.append('doctype', 'Delivery Note');
        formData2.append('filters', JSON.stringify([["Delivery Note", "pick_list", "is", "set"], ["Delivery Note", "status", "=", "Draft"]]));
        formData2.append('distinct', false);
        // formData2.append('fields', []);
        const response2 = await CountApi2(formData2);

        const formData3 = new FormData();
        formData3.append('doctype', 'Pick List');
        formData3.append('filters', JSON.stringify([["Pick List", "pick_status_st", "=", "Delivery Note Created"]]));
        formData3.append('distinct', false);
        const response3 = await CountApi2(formData3);


        store({
          option1: response.data.message,  // pending
          option2: response3.data.message, // process
          option3: response2.data.message  // complete
        });

      } catch (error) {
        console.error("Error in Find_Annual_Purchase_Count:", error);
      }
    };

    CountFunApi(filters, setDeliveryNoteInfoCount);

  }, [Total_delivery_note_Filters, selectedComapny]);





  // Dashboard cards data
  const charts = [
    {
      type: "Purchase_Order_Trends",
      title: "Warehouse wise Stock Value",
      component: <ReactBarChart data={!Purchase_order_trends?.labels ? {} : {chart:{data:{labels:Purchase_order_trends?.labels,datasets:Purchase_order_trends?.datasets}}}} />,
      fields: ["period", "fiscal_year"]
    },
    {
      type: "Material_Request_Analysis",
      title: "Purchase Receipt Trends",
      component: <ReactBarChart data={!Material_Request_Analysis?.labels ? {} : {chart:{data:{labels:Material_Request_Analysis?.labels,datasets:Material_Request_Analysis?.datasets}}}} />,
      fields: ["period", "fiscal_year"]
    },
    {
      type: "Purchase_Order_Analysis",
      title: "Delivery Trends",
      component: <ReactBarChart
      data={!Purchase_order_analysis?.labels ? {} : {chart:{data:{labels:Purchase_order_analysis?.labels,datasets:Purchase_order_analysis?.datasets}}}}
     />,
      fields: ["from_date", "to_date", "status"]
    },
    {
      type: "Item_Wise_Annual_Purchase",
      title: "Oldest Items",
      component: <ReactBarChart data={item_wise_annual_Purchase} color={'#391f84'} />,
      fields: ["from_date", "to_date"]
    }
    // ,
    // {
    //   type: "item_Shortage_Summary",
    //   title: "item Shortage Summary",
    //   component: <ReactBarChart data={item_Shortage_Summary} color={'#391f84'} />,
    //   fields: ["from_date", "to_date"]
    // }
  ];

 

  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Helmet>
          <title>Stock Dashboard</title>
      </Helmet>
      <Header />
      <div className="container-fluid dashboard-container py-0 px-3">
         <Tabs />
        <div className="row dashboard-header py-2" style={{ marginBottom: "0px" }}>
          <div className="col-12">
            <h5 className="mb-0" style={{ color: "#823455" }}>Stock Dashboard</h5>
          </div>
        </div>

         {/* <NumberCard selectedComapny={selectedComapny} /> */}


          <div className="row mb-4" >
            <DashTable
        Count1={GrnInfoCount}
        Count2={SalesOrderInfoCount}
        Count3={SalesInvoiceInfoCount}
        title={["GRN","Sales Order","Sales Invoice"]}
        label="Transactions"
      />


      <div className="col-md-4" >
                <div className="dashboard-card m-0" style={{ height: "100%" }}>
                  <h5 className="d-flex justify-content-between" style={{ fontSize: "15px", fontWeight: "700" }}>
                    <span>Gate Entry</span>
                    <span 
                      onClick={() => { 
                        setCurrentChartType("gate entry"); 
                        setShowChartPopup(true); 
                      }} 
                      style={{ cursor: "pointer" }}
                    >
                      <GetIcon iconName="IoFilterSharp" size={15} />
                    </span>
                  </h5>
                  <ReactDonutChart data={{
                        "chart": {
                            "data": {
                                "labels": [
                                    "Total Gate Entry",
                                    "Pending For GRN"
                                ],
                                "datasets": [
                                    {
                                        "values": [
                                          GateEntryandPendingGRNCount?.total_gate_entry,
                                            GateEntryandPendingGRNCount?.pending_gate_entry
                                        ]
                                    }
                                ]
                            }
                        },
                    }} />
                </div>
              </div>


<DashTable
         type={0}
        label="Transactions"
        Count1={DeliveryNoteInfoCount}
        Count2={PickListInfoCount}
        Count3={PutAwayInfoCount}
        title={["Put Away","Pick List","Delivery Note"]}
      />


          </div>



        {[0, 3].map((startIdx) => (
          <div className="row mb-4" key={startIdx}>
            {charts.slice(startIdx, startIdx + 3).map((chart) => (
              <div className="col-md-4" key={chart.type}>
                <div className="dashboard-card m-0" style={{ height: "100%" }}>
                  <h5 className="d-flex justify-content-between" style={{ fontSize: "15px", fontWeight: "700" }}>
                    <span>{chart.title}</span>
                    <span 
                      onClick={() => { 
                        setCurrentChartType(chart.type); 
                        setShowChartPopup(true); 
                      }} 
                      style={{ cursor: "pointer" }}
                    >
                      <GetIcon iconName="IoFilterSharp" size={15} />
                    </span>
                  </h5>
                  {chart.component}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>

      <ChartFilterPopup
        show={showChartPopup}
        onClose={() => setShowChartPopup(false)}
        filters={getCurrentChartFilters()}
        setFilters={(newFilters) => updateFilters(currentChartType, newFilters)}
        fields={charts.find(c => c.type === currentChartType)?.fields || []}
      />

  

      <Footer /> 
    </div>
  );
};

export default Dashboard;